import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getVisibleNotificationsConfig,
  getFilters,
  getPagination,
  getIsLoading,
} from 'notifications_config/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as NotificationsConfig from 'notifications_config/components';
import NotificationConfigRowContainer from 'notifications_config/containers/NotificationConfigRowContainer';
import NotificationsConfigListHandlers from 'notifications_config/containers/NotificationsConfigListHandlers';

import { toggle } from 'notifications_config/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class NotificationsConfigListContainer extends Component {
  renderRows = () =>
    this.props.notifications_config.map((notificationConfig) => (
      <NotificationConfigRowContainer
        key={notificationConfig.id}
        notificationConfig={notificationConfig}
        handleToggle={this.handleToggle}
      />
    ));

  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <NotificationsConfigListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <NotificationsConfig.ListView
          count={this.props.notifications_config.length}
          filters={this.props.filters}
          company={this.props.company}
          handleToggle={this.handleToggle}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </NotificationsConfig.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  notifications_config: getVisibleNotificationsConfig(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsConfigListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/containers/NotificationsConfigListContainer.js